module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/AGRICULTURE-21bf3c47a1941f86e2095b1f5adc55c3.png";